import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractRoutingModule } from './contract-routing.module';
import { ContractComponent } from './contract.component';
import { ContractListComponent } from './contract-list/contract-list.component';
import { ContractRequestComponent } from './contract-request/contract-request.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../shared/shared.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ContractPreviewComponent } from './contract-preview/contract-preview.component';
import { ContractDetailsComponent } from './contract-details/contract-details.component';
import { VersionConfirmationDialogComponent } from './pop-ups/version-confirmation-dialog/version-confirmation-dialog.component';
import { DiscardConfirmationDialogComponent } from './pop-ups/discard-confirmation-dialog/discard-confirmation-dialog.component';
import { ResignConfirmationDialogComponent } from './pop-ups/resign-confirmation-dialog/resign-confirmation-dialog.component';
import { NewUserCreationWarningDialogComponent } from './pop-ups/new-user-creation-warning-dialog/new-user-creation-warning-dialog.component';
import { MainPipe } from '../shared/pipe/main.pipe.module';

@NgModule({
  declarations: [
    ContractComponent,
    ContractListComponent,
    ContractRequestComponent,
    ContractPreviewComponent,
    ContractDetailsComponent,
    VersionConfirmationDialogComponent,
    DiscardConfirmationDialogComponent,
    ResignConfirmationDialogComponent,
    NewUserCreationWarningDialogComponent,
  ],
  imports: [
    CommonModule,
    ContractRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    DragDropModule,
    MainPipe,
    InfiniteScrollModule,
  ],
  providers: [],
  exports: [
    ContractListComponent,
    ContractRequestComponent
  ]
})
export class ContractModule { }
